// removeInsertValuesRow — VQE-Edit edit-action: drop a VALUES row by 0-based
// list index via SR-Edit's `remove-insert-values-row` op. SR-Edit handles the
// comma-stripping; this module only validates the index against an optional
// structure and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — DML edits.

import type { QueryStructure } from '../../../../sql-resolver/types/queryStructure';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

export type RemoveInsertValuesRowOptions = {
  /**
   * Optional structure used for index-bounds validation. Lets the caller
   * surface a friendlier error than SR-Edit's silent "no edits" response.
   */
  readonly structure?: QueryStructure;
};

export async function removeInsertValuesRow(
  index: number,
  ctx: CommitEditCtx,
  options: RemoveInsertValuesRowOptions = {},
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(
      `removeInsertValuesRow: index must be a non-negative integer (got ${index})`,
    );
  }
  if (options.structure) {
    const rows = options.structure.insertValuesRows ?? [];
    if (rows.length === 0) {
      throw new Error('removeInsertValuesRow: VALUES list is empty');
    }
    if (index >= rows.length) {
      throw new Error(
        `removeInsertValuesRow: index ${index} out of range (VALUES list has ${rows.length} row(s))`,
      );
    }
  }
  await commitEdit({ op: 'remove-insert-values-row', index }, ctx);
}
